module.exports = __webpack_public_path__ + "static/gallery_kerry_2-1fba03c869b2a43a046133dd716f1840.jpg";